import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

const Category3 = ({transfer2,value,item,transfer3}) => {
      const { bgColor, textColor } = useSelector((state) => state.theam);
      const [activesubmenu,setactivesubmenu] = useState(false)
    return (
        <div className="menu-title">
            <div className="d-flex justify-content-between">
                <h5 onClick={() => { transfer2(item.id, item.name, value.category_name) }}
                    style={{ marginBottom: item.children.length > 0 ? "5px" : '10px', fontWeight: "400", color: decodeURIComponent(window.location.href).includes(item.name) ? `#${textColor}` : '' }}
                >
                    {item.name}
                </h5> <span style={{ position: 'relative', left: '21px',display:item.children.length == 0 ? "none" : '' }} onClick={()=>{setactivesubmenu(!activesubmenu)}} ><MdOutlineKeyboardArrowRight /></span> </div>
              {item.children.length > 0 ? <ul style={{ paddingLeft: '10px', marginBottom: '11px',display:!activesubmenu ? "none" : "" }}>
                {item.children.map((childrenitem, index) => (
                    <li>
                        <p onClick={() => { transfer3(childrenitem.id, item.name, value.category_name, childrenitem.name) }} style={{ fontSize: '11px', color: decodeURIComponent(window.location.href).includes(childrenitem.name) ? `#${textColor}` : '#444444' }}>{childrenitem.name}</p>
                    </li>
                ))}
            </ul> : ''}

        </div>
    )
}

export default Category3